import { signOut, User } from '@firebase/auth'
import { doc, getDoc } from '@firebase/firestore'
import { getDownloadURL, ref } from '@firebase/storage'
import axios from 'axios'

import { auth, BASE_COLLECTION, db, storage } from 'config/firebase'
import { FirebaseOrganisationData } from 'types/firebase'
import { UserDataResponse } from 'types/server/user-details'

async function fetchSessionContext(user: User) {
	const userToken = await user.getIdToken()
	const response = await axios.get(`${process.env.REACT_APP_API_URL}/session`, {
		headers: {
			Authorization: userToken,
		},
	})
	return response.data
}

export async function initClientSession(user: User) {
	try {
		const userDetails = (await fetchSessionContext(user)) as UserDataResponse

		const logoRef = ref(storage, `organisations/${userDetails.orgId}/images/logo.png`)
		const logo = await getDownloadURL(logoRef)

		const docRef = doc(db, `${BASE_COLLECTION}`, userDetails.orgId)
		const docSnap = await getDoc(docRef)
		if (!docSnap.exists()) throw new Error('No Mockinbird Data')

		const orgData = docSnap.data() as FirebaseOrganisationData

		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { stripeCustomerId, ambiguous_locations, ...restOrgData } = orgData

		return { ...restOrgData, ...userDetails, logo: logo, ...userDetails?.orgMembers }
	} catch {
		console.log('Error signing and fetching client data')
		signOut(auth)
		return null
	}
}
